import React, { useEffect, useState } from "react";
import FilterDropdown from "./FilterDropdown";
import useSearchFilter from "hooks/useSearchFilter";
import { useSearchParams } from "react-router-dom";
import { floorOptionList, formatSelectedFloorsText } from "utils/searchFilter";
import { ReactComponent as FloorFilterIcon } from "assets/icons/floor_filter.svg";
import FilterButton from "components/Buttons/FilterButton";
import { formatStringForUrl } from "utils/formatUrl";

const FloorFilter = () => {
  const { typeOfFloor, setTypeOfFloor } = useSearchFilter();
  const [floorText, setFloorText] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = (selectedFloors) => {
    const newParams = new URLSearchParams(searchParams.toString());
    newParams.delete("floor");
    selectedFloors.forEach((floor) => {
      const formattedTitle = formatStringForUrl(floor.title);
      newParams.append("floor", formattedTitle);
    });
    setSearchParams(newParams);
  };

  // Handle the selection and deselection of floor options
  const handleFloor = (floor) => {
    const isSelected = typeOfFloor.some((val) => val.id === floor.id);

    if (isSelected) {
      // Deselect the floor
      const updatedFloors = typeOfFloor.filter((val) => val.id !== floor.id);
      setTypeOfFloor(updatedFloors);
      updateSearchParams(updatedFloors);
      setFloorText(formatSelectedFloorsText(updatedFloors));
    } else {
      // Select the floor
      const updatedFloors = [...typeOfFloor, floor];
      setTypeOfFloor(updatedFloors);
      updateSearchParams(updatedFloors);
      setFloorText(formatSelectedFloorsText(updatedFloors));
    }
  };

  // Set initial values based on URL parameters
  useEffect(() => {
    const initialFloors = searchParams.getAll("floor");
    const floorObjects = floorOptionList.filter((option) =>
      initialFloors.includes(formatStringForUrl(option.title))
    );
    setTypeOfFloor(floorObjects);
    setFloorText(formatSelectedFloorsText(floorObjects));
  }, [searchParams, setTypeOfFloor]);

  return (
    <FilterDropdown
      selectedItem={floorText}
      id="piano"
      placeholder="Piano"
      dropdownStyle={{ width: 280 }}
      Icon={FloorFilterIcon}
    >
      <div className="p-4">
        <ul className="flex items-center gap-y-2 gap-x-2 flex-wrap">
          {floorOptionList.map((floor) => {
            const isFloorMatched = typeOfFloor.some(
              (val) => val.id === floor.id
            );
            return (
              <li
                key={floor.id}
                className={`w-fit px-[14px] flex-shrink-0 h-[32px] border text-[12px] flex items-center justify-center cursor-pointer rounded-[8px] border-[#F0EFFB]  transition-all duration-300 ease-in ${
                  isFloorMatched
                    ? "bg-primary text-white "
                    : "text-black bg-transparent hover:bg-[#EAEAEA]"
                }`}
                onClick={() => handleFloor(floor)}
              >
                {floor.title}
              </li>
            );
          })}
        </ul>
      </div>
      <FilterButton />
    </FilterDropdown>
  );
};

export default FloorFilter;
